import React from "react";
import InteractiveDots from "@/components/layout/InteractiveDots";
import BrandLogo from "@/components/ui/BrandLogo";
import { COLORS, FONTS, LAYOUT } from "@/constants/theme";

const PLATFORM_LINKS = [
  { label: "Propuesta de valor", href: "#propuesta-valor" },
  { label: "Servicios", href: "#servicios" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Contacto", href: "#contacto" },
];

/**
 * Pie de página institucional.
 *
 * @returns {JSX.Element}
 */
const Footer = () => {
  return (
    <footer
      className="relative overflow-hidden px-6 pb-7 pt-16"
      style={{
        backgroundColor: COLORS.bgPrimary,
        borderTop: `1px solid ${COLORS.borderSubtle}`,
        backgroundImage: `linear-gradient(180deg, ${COLORS.bgSecondary} 0%, ${COLORS.bgPrimary} 100%)`,
      }}
    >
      {/* Misma malla reactiva que el hero: cierra la página con el mismo lenguaje. */}
      <InteractiveDots />

      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background: `radial-gradient(ellipse at 50% 40%, transparent 40%, ${COLORS.bgPrimary} 100%)`,
          opacity: 0.6,
        }}
      />

      {/* -- Footer -- */}
      <div className="relative mx-auto" style={{ maxWidth: LAYOUT.maxWidth }}>
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <BrandLogo size="lg" />
            <p
              className="mt-3 max-w-[320px] text-[1rem]"
              style={{
                color: COLORS.textSecondary,
                fontFamily: FONTS.body,
                lineHeight: 1.6,
              }}
            >
              Tecnología que opera al nivel de tu institución.
            </p>
          </div>

          <div>
            <p
              className="text-[0.82rem] uppercase"
              style={{
                color: COLORS.textMuted,
                fontFamily: FONTS.heading,
                letterSpacing: "0.08em",
              }}
            >
              Navegación
            </p>
            <nav className="mt-2 flex flex-col">
              {PLATFORM_LINKS.map((link) => (
                <a
                  className="nav-enlace-pie"
                  href={link.href}
                  key={link.label}
                  style={{
                    color: COLORS.textSecondary,
                    fontFamily: FONTS.body,
                    fontSize: "1rem",
                    display: "flex",
                    alignItems: "center",
                    minHeight: "44px",
                  }}
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <p
              className="text-[0.82rem] uppercase"
              style={{
                color: COLORS.textMuted,
                fontFamily: FONTS.heading,
                letterSpacing: "0.08em",
              }}
            >
              Ecuador
            </p>
            <ul className="mt-3 space-y-2">
              <li style={{ color: COLORS.textSecondary, fontFamily: FONTS.body, fontSize: "1rem" }}>contacto@altamaec.com</li>
              <li style={{ color: COLORS.textSecondary, fontFamily: FONTS.body, fontSize: "1rem" }}>Guayaquil, Ecuador.</li>
              <li style={{ color: COLORS.textSecondary, fontFamily: FONTS.body, fontSize: "1rem" }}>Lunes a viernes, 9:00 - 18:00.</li>
            </ul>
          </div>
        </div>

        <div
          className="mt-10 flex flex-col gap-3 pt-5 text-[0.95rem] md:flex-row md:items-center md:justify-between"
          style={{ borderTop: `1px solid ${COLORS.borderSubtle}` }}
        >
          <p style={{ color: COLORS.textMuted, fontFamily: FONTS.body }}>© 2026 ALTAMA CONSULTING. Todos los derechos reservados.</p>
          <p style={{ color: COLORS.textMuted, fontFamily: FONTS.body }}>Hecho en Ecuador.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
